"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Cell = function (_a) {
    var testID = _a.testID, children = _a.children, className = _a.className, _b = _a.colSpan, colSpan = _b === void 0 ? 1 : _b, onClick = _a.onClick;
    return (react_1.default.createElement("td", { className: className, colSpan: colSpan, onClick: onClick, "data-test-id": testID }, children));
};
var BaseCell = styled_components_1.default(Cell)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: ", ";\n  pointer-events: ", ";\n  position: relative;\n  font-size: 16px;\n  line-height: 21px;\n  box-sizing: border-box;\n  text-align: ", ";\n  color: ", ";\n"], ["\n  cursor: ", ";\n  pointer-events: ", ";\n  position: relative;\n  font-size: 16px;\n  line-height: 21px;\n  box-sizing: border-box;\n  text-align: ", ";\n  color: ",
    ";\n"])), function (_a) {
    var onClick = _a.onClick, disabled = _a.disabled;
    return (disabled ? 'not-allowed' : onClick ? 'pointer' : 'default');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'auto');
}, function (_a) {
    var alignRight = _a.alignRight;
    return (alignRight ? 'right' : 'left');
}, function (_a) {
    var commonRow = _a.theme.colours.commonRow, disabled = _a.disabled;
    return (disabled ? commonRow.disabled : 'inherit');
});
exports.FadedCell = styled_components_1.default(BaseCell)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  pointer-events: ", ";\n  color: ", ";\n"], ["\n  pointer-events: ", ";\n  color: ",
    ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'auto');
}, function (_a) {
    var commonRow = _a.theme.colours.commonRow, disabled = _a.disabled;
    return (disabled ? commonRow.disabled : commonRow.color);
});
exports.FadedCell.displayName = 'FadedCell';
var StyledCell = styled_components_1.default(BaseCell)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  pointer-events: ", ";\n  color: ", ";\n"], ["\n  pointer-events: ", ";\n  color: ",
    ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'auto');
}, function (_a) {
    var commonRow = _a.theme.colours.commonRow, faded = _a.faded, disabled = _a.disabled;
    return (disabled ? commonRow.disabled : faded ? commonRow.faded : 'inherit');
});
Cell.displayName = 'Cell';
exports.default = StyledCell;
var templateObject_1, templateObject_2, templateObject_3;
